import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-title" }
const _hoisted_4 = { class: "relative sm:w-[265px]" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "trezo-card-subtitle mt-[15px] sm:mt-0" }
const _hoisted_7 = { class: "inline-block relative ltr:pl-[22px] rtl:pr-[22px]" }
const _hoisted_8 = { class: "trezo-card-content -mx-[20px] md:-mx-[25px]" }
const _hoisted_9 = {
  key: 0,
  class: "flex justify-center items-center py-10"
}
const _hoisted_10 = {
  key: 1,
  class: "text-center py-10"
}
const _hoisted_11 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_12 = { class: "flex justify-center gap-4 mt-4" }
const _hoisted_13 = {
  key: 2,
  class: "table-responsive overflow-x-auto"
}
const _hoisted_14 = { class: "w-full" }
const _hoisted_15 = { class: "text-black dark:text-white" }
const _hoisted_16 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_17 = { class: "font-medium text-center px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_18 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_19 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_20 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_21 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_22 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_23 = { class: "text-black dark:text-white" }
const _hoisted_24 = { class: "ltr:text-left rtl:text-right whitespace-nowrap p-[20px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_25 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_26 = { class: "text-center whitespace-nowrap p-[20px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_27 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_28 = { class: "ltr:text-left rtl:text-right whitespace-nowrap p-[20px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_29 = { class: "ltr:text-left rtl:text-right whitespace-nowrap p-[20px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_30 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_31 = { class: "ltr:text-left rtl:text-right whitespace-nowrap p-[20px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_32 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_33 = { class: "ltr:text-left rtl:text-right whitespace-nowrap p-[20px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_34 = { class: "ltr:text-left rtl:text-right whitespace-nowrap p-[20px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_35 = { class: "flex items-center gap-[9px]" }
const _hoisted_36 = ["data-text", "onClick"]
const _hoisted_37 = ["data-text", "onClick"]
const _hoisted_38 = ["data-text", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("label", { class: "leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2" }, [
            _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, " search ")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            placeholder: _ctx.directT('crm.deals.searchDeal'),
            class: "bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400"
          }, null, 8, _hoisted_5), [
            [_vModelText, _ctx.searchTerm]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          class: "inline-block transition-all rounded-md font-medium px-[13px] py-[6px] text-primary-500 border border-primary-500 hover:bg-primary-500 hover:text-white",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.activeBtn && _ctx.stateStoreInstance.activeBtn(...args)))
        }, [
          _createElementVNode("span", _hoisted_7, [
            _cache[6] || (_cache[6] = _createElementVNode("i", { class: "material-symbols-outlined !text-[22px] absolute ltr:-left-[4px] rtl:-right-[4px] top-1/2 -translate-y-1/2" }, " add ", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.deals.addNewDeal')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[7] || (_cache[7] = [
            _createElementVNode("div", { class: "spinner" }, null, -1)
          ])))
        : (_ctx.deals.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.directT('crm.deals.noDealsFound')), 1),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.fetchAllDeals && _ctx.fetchAllDeals(...args))),
                  class: "px-4 py-2 bg-primary-500 text-white rounded-md"
                }, _toDisplayString(_ctx.directT('crm.deals.tryAltLoading')), 1),
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.checkTablesAndDebugging && _ctx.checkTablesAndDebugging(...args))),
                  class: "px-4 py-2 bg-blue-500 text-white rounded-md"
                }, _toDisplayString(_ctx.directT('crm.deals.debugConnection')), 1),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.createTestDeal && _ctx.createTestDeal(...args))),
                  class: "px-4 py-2 bg-green-500 text-white rounded-md"
                }, _toDisplayString(_ctx.directT('crm.deals.createTestDeal')), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("table", _hoisted_14, [
                _createElementVNode("thead", _hoisted_15, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.directT('crm.deals.id')), 1),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.directT('crm.deals.title')), 1),
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.directT('crm.deals.contactPerson')), 1),
                    _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.directT('crm.deals.amount')), 1),
                    _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.directT('crm.deals.createdAt')), 1),
                    _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.directT('crm.deals.status')), 1),
                    _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.directT('crm.deals.action')), 1)
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDeals, (deal) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: deal.id
                    }, [
                      _createElementVNode("td", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.shortId(deal.id)), 1)
                      ]),
                      _createElementVNode("td", _hoisted_26, [
                        _createElementVNode("span", _hoisted_27, _toDisplayString(deal.title), 1)
                      ]),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(deal.first_name && deal.last_name ? `${deal.first_name} ${deal.last_name}` : (deal.name || _ctx.directT('crm.deals.notDefined'))), 1),
                      _createElementVNode("td", _hoisted_29, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.formatCurrency(deal.amount)), 1)
                      ]),
                      _createElementVNode("td", _hoisted_31, [
                        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.formatDate(deal.created_at)), 1)
                      ]),
                      _createElementVNode("td", _hoisted_33, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["px-[8px] py-[3px] inline-block rounded-sm font-medium text-xs", {
                    'bg-primary-50 dark:bg-[#15203c] text-primary-500': deal.status === 'new',
                    'bg-green-50 dark:bg-[#15203c] text-green-500': deal.status === 'in progress',
                    'bg-yellow-50 dark:bg-[#15203c] text-yellow-500': deal.status === 'negotiation',
                    'bg-blue-50 dark:bg-[#15203c] text-blue-500': deal.status === 'closed won',
                    'bg-red-50 dark:bg-[#15203c] text-red-500': deal.status === 'closed lost'
                  }])
                        }, _toDisplayString(_ctx.getStatusText(deal.status)), 3)
                      ]),
                      _createElementVNode("td", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "text-primary-500 leading-none custom-tooltip",
                            id: "customTooltip",
                            "data-text": _ctx.directT('crm.deals.view'),
                            onClick: ($event: any) => (_ctx.viewDeal(deal.id))
                          }, _cache[8] || (_cache[8] = [
                            _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                          ]), 8, _hoisted_36),
                          _createElementVNode("button", {
                            type: "button",
                            class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                            id: "customTooltip",
                            "data-text": _ctx.directT('crm.deals.edit'),
                            onClick: ($event: any) => (_ctx.editDeal(deal.id))
                          }, _cache[9] || (_cache[9] = [
                            _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                          ]), 8, _hoisted_37),
                          _createElementVNode("button", {
                            type: "button",
                            class: "text-danger-500 leading-none custom-tooltip",
                            id: "customTooltip",
                            "data-text": _ctx.directT('crm.deals.delete'),
                            onClick: ($event: any) => (_ctx.confirmDeleteDeal(deal.id))
                          }, _cache[10] || (_cache[10] = [
                            _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                          ]), 8, _hoisted_38)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])),
      _createVNode(_component_Pagination, {
        items: 10,
        total: 36,
        class: "px-[20px] md:px-[25px] pt-[12px] md:pt-[14px]"
      })
    ])
  ]))
}